import { useEffect } from 'react'
import { Drawer, Typography } from '@evocolabs/orkaui'
import { Box } from '@mui/material'
import style from '@/pages/scss/OrkaTwo.module.scss'
import imgs from '../data/imgs'

import { disableBack, recoverDisableBack } from '@/src/utils/historyImprove'

const { warrantyImgs } = imgs
const data = {
  title: `Warranty`,
  list: [
    {
      title: '3-Year Warranty',
      subTitle:
        'Receive a brand new product for damages (not intentional) to your current device.',
      icon: warrantyImgs[0]
    },
    {
      title: '45-Day Risk Free Trial',
      subTitle:
        'Full refund anytime within the 45-day trial period, no obligations.',
      icon: warrantyImgs[1]
    },
    {
      title: 'Free Shipping & Return',
      subTitle: 'Free shipping and returns on all your orders.',
      icon: warrantyImgs[2]
    }
  ]
}

const RenderItem = function ({ IconClass, title, subTitle } = props) {
  return (
    <Box display="flex" mb="32px">
      <Box width="64px" height="64px">
        <IconClass size={64} />
      </Box>
      <Box display="flex" flexDirection="column" ml="8px">
        <Typography variant="T2">{title}</Typography>
        <Typography variant="body2" mt="8px">
          {subTitle}
        </Typography>
      </Box>
    </Box>
  )
}
const Warranty = function ({ open, onClose } = props) {
  useEffect(() => {
    if (open) {
      disableBack(() => {
        recoverDisableBack()
        onClose()
      })
    }
  }, [open])

  return (
    <>
      <Drawer
        open={open}
        onClose={onClose}
        disableMobSizeAdjustment={true}
        sx={{
          top: { xs: '48px', dl: '0' },
          '>.MuiPaper-root': { top: { xs: '48px', dl: '0' } },
          ' .orkaui-drawer-container': {
            paddingBottom: '0',
            display: 'flex',
            height: '100%'
          }
        }}
      >
        <Box display="flex" flexDirection="column" height="100%">
          <Typography variant="h3">{data.title}</Typography>
          <Box mt="32px" className={style['warranty-box']}>
            {data.list.map((d) => (
              <RenderItem
                IconClass={d.icon}
                title={d.title}
                subTitle={d.subTitle}
                key={d.title}
              />
            ))}
          </Box>
        </Box>
      </Drawer>
    </>
  )
}

export default Warranty
